<!-- <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar> -->
<div *ngIf="reportages && headerLoaded && !showProductsGrid">
  <div class="header-wrapper">
    <div class="header-photo">
      <img [src]="headerData['reportage_image']" alt="Reportaje logo" />
    </div>
    <div class="header-school-data">
      <!-- <p style="text-transform: uppercase;">{{ 'menu.grade' | translate }}: {{headerData['yearperiod_name']}}</p> -->
      <p>{{ headerData["name"] }}</p>
    </div>

    <mat-divider [vertical]="true"></mat-divider>

    <div class="header-student-data">
      <!-- <p> {{ reportages['name'] }}</p>
            <p><span>{{ 'menu.stage' | translate }}: </span> {{ reportages['stage_name'] }}</p>
            <p><span>{{ 'menu.class' | translate }}: </span> {{ reportages['grade_name'] }}</p>
            <p><span>{{ 'tables.num_list' | translate }}: </span> {{ reportages['num_list'] }}</p> -->
      <p style="text-transform: uppercase">
        {{ headerData["yearperiod_name"] }}
      </p>
    </div>
  </div>
  <!-- Button design for desktop -->
  <div
    *ngIf="!tpv_payment && !mobileLandscapeImage"
    class="floating-button-wrapper"
    (mouseenter)="hoverOn('order_btn')"
    (mouseleave)="hoverOff('order_btn')"
  >
    <!-- <button *ngIf="!showReservationSummary" mat-flat-button matBadge="{{badgeNumber > 0 ? badgeNumber : null}}"
            (click)="proceedToReservationCheckout()" [disabled]="badgeNumber < 1"
            [ngClass]="{'disabled-button': badgeNumber < 1}">
            <span>{{ 'buttons.order' | translate }}</span>
            <mat-icon>shopping_bag</mat-icon>
        </button> -->

    <button
      *ngIf="!showReservationSummary && !mobileLandscapeImage"
      class="reservation-button"
      [ngClass]="{ 'extended-fab-button': floatingButtonExtend }"
      mat-fab
      color="primary"
      matBadge="{{ badgeNumber > 0 ? badgeNumber : null }}"
      (click)="proceedToReservationCheckout()"
      [disabled]="badgeNumber < 1"
    >
      <span
        [ngClass]="{ animation: floatingButtonExtend }"
        [hidden]="!floatingButtonExtend"
        >{{ "buttons.order" | translate }}</span
      >
      <mat-icon>shopping_bag</mat-icon>
    </button>
  </div>

  <!-- Button design for mobile -->
  <div
    *ngIf="!tpv_payment && mobileLandscapeImage"
    class="floating-button-wrapper-scale-down"
    (mouseenter)="hoverOn('order_btn')"
    (mouseleave)="hoverOff('order_btn')"
  >
    <button
      *ngIf="!showReservationSummary && mobileLandscapeImage"
      class="reservation-button extended-fab-button scale-down"
      mat-fab
      color="primary"
      matBadge="{{ badgeNumber > 0 ? badgeNumber : null }}"
      (click)="proceedToReservationCheckout()"
      [disabled]="badgeNumber < 1"
    >
      <span>{{ "buttons.order" | translate }}</span>
      <mat-icon>shopping_bag</mat-icon>
    </button>
  </div>

  <!-- Floating back button for reservation page -->
  <div class="floating-button-wrapper-down">
    <button
      *ngIf="showReservationSummary"
      mat-flat-button
      (click)="stepperIndexHandler('back')"
      style="background-color: white; color: #5fbeb5; border: 1px solid #5fbeb5"
    >
      <mat-icon style="color: #5fbeb5; margin-right: 8px"
        >keyboard_backspace</mat-icon
      >
      <span style="color: #5fbeb5">{{ "buttons.return" | translate }}</span>
    </button>
    <button
      *ngIf="showReservationSummary && mobileSummaryItems && stepperIndex == 0"
      mat-flat-button
      (click)="stepperIndexHandler('next')"
      style="
        background-color: #5fbeb5;
        color: white;
        border: 1px solid #5fbeb5;
        margin-left: 6px;
      "
    >
      <mat-icon style="color: white; margin-right: 8px">arrow_right</mat-icon>
      <span style="color: white">{{ "inputs.next" | translate }}</span>
    </button>
  </div>

  <div
    *ngIf="tpv_payment && !mobileLandscapeImage"
    class="floating-button-wrapper"
    (mouseenter)="hoverOn('order_btn')"
    (mouseleave)="hoverOff('order_btn')"
  >
    <!-- <button mat-flat-button matBadge="{{badgeNumber > 0 ? badgeNumber : null}}" (click)="goTo('/shopping-cart')"
            [disabled]="badgeNumber < 1" [ngClass]="{'disabled-button': badgeNumber < 1}">
            <span>Cesta</span>
            <mat-icon>shopping_cart</mat-icon>
        </button> -->

    <button
      *ngIf="!showReservationSummary"
      class="reservation-button"
      [ngClass]="{ 'extended-fab-button': floatingButtonExtend }"
      mat-fab
      color="primary"
      matBadge="{{ badgeNumber > 0 ? badgeNumber : null }}"
      (click)="goTo('/shopping-cart')"
      [disabled]="badgeNumber < 1"
    >
      <span
        [ngClass]="{ animation: floatingButtonExtend }"
        [hidden]="!floatingButtonExtend"
        >{{ "buttons.cart" | translate }}</span
      >
      <mat-icon>shopping_cart</mat-icon>
    </button>
  </div>

  <div
    *ngIf="tpv_payment && mobileLandscapeImage"
    class="floating-button-wrapper-scale-down"
    (mouseenter)="hoverOn('order_btn')"
    (mouseleave)="hoverOff('order_btn')"
  >
    <!-- <button mat-flat-button matBadge="{{badgeNumber > 0 ? badgeNumber : null}}" (click)="goTo('/shopping-cart')"
            [disabled]="badgeNumber < 1" [ngClass]="{'disabled-button': badgeNumber < 1}">
            <span>Cesta</span>
            <mat-icon>shopping_cart</mat-icon>
        </button> -->

    <button
      *ngIf="!showReservationSummary"
      class="reservation-button extended-fab-button scale-down"
      mat-fab
      color="primary"
      matBadge="{{ badgeNumber > 0 ? badgeNumber : null }}"
      (click)="goTo('/shopping-cart')"
      [disabled]="badgeNumber < 1"
    >
      <span>{{ "buttons.cart" | translate }}</span>
      <mat-icon>shopping_cart</mat-icon>
    </button>
  </div>
</div>

<!-- <mat-paginator [length]=100 [pageSizeOptions]="[20, 50, 100]"
    (page)="pageEvent = $event; onPaginateChange($event)" showFirstLastButtons>
</mat-paginator> -->

<div
  *ngIf="total_products < 1 && !loading"
  style="text-align: center; margin-top: 24px"
>
  <!-- <p style="font-size: 18px; font-weight: 500;">{{'text.no_products_available' | translate}}
    </p> -->
  <div style="flex-direction: row" style="display: {{ 'es' | translate }}">
    <p style="font-size: 18px; font-weight: 500">{{ msg.es }}</p>
  </div>
  <div style="flex-direction: row" style="display: {{ 'en' | translate }}">
    <p style="font-size: 18px; font-weight: 500">{{ msg.en }}</p>
  </div>
  <div style="flex-direction: row" style="display: {{ 'cat' | translate }}">
    <p style="font-size: 18px; font-weight: 500">{{ msg.cat }}</p>
  </div>
</div>

<div style="text-align: center; margin-top: 24px">
    <!-- <p style="font-size: 18px; font-weight: 500;">{{'text.no_products_available' | translate}}
        </p> -->
    <div style="flex-direction: row" style="display: {{ 'es' | translate }}">
      <p style="font-size: 18px; font-weight: 500">
        {{ msg ? msg.notification_es : "" }}
      </p>
    </div>
    <div style="flex-direction: row" style="display: {{ 'en' | translate }}">
      <p style="font-size: 18px; font-weight: 500">
        {{ msg ? msg.notification_en : "" }}
      </p>
    </div>
    <div style="flex-direction: row" style="display: {{ 'cat' | translate }}">
      <p style="font-size: 18px; font-weight: 500">
        {{ msg ? msg.notification_cat : "" }}
      </p>
    </div>
  </div>
<!-- PRIORITY PRODUCTS GRID -->
<div *ngIf="!showProductsGrid">
  <div class="grid">
    <div class="centered">
      <div *ngFor="let product of highlightedProducts">
        <div class="grid-element highlighted">
          <div class="item item-centered">
            <div>
              <img
              class="grid-image"
              [src]="product.product_image"
              (click)="!mobileView && openPhotoPreview(product.product_image)"
              [ngClass]="{ 'zoom-in-cursor': !mobileView }"
            />
              <!-- <img class="grid-image" [src]="product.product_image" /> -->
            </div>

            <div class="grid-card-title">
              <span style="display: {{ 'es' | translate }}">{{
                product.name_es
              }}</span>
              <span style="display: {{ 'en' | translate }}">{{
                product.name_en
              }}</span>
              <span style="display: {{ 'cat' | translate }}">{{
                product.name_cat
              }}</span>
            </div>
            <mat-divider style="width: 95%"></mat-divider>
            <div
              *ngFor="
                let description of highlightedProductDescriptions[product.id]
              "
            >
              <div>
                <span style="display: {{ 'es' | translate }}"
                  >{{ description.unit ? description.unit : "*" }} &nbsp;
                  {{ description.description_es }}</span
                >
                <span style="display: {{ 'en' | translate }}"
                  >{{ description.unit ? description.unit : "*" }} &nbsp;
                  {{ description.description_en }}</span
                >
                <span style="display: {{ 'cat' | translate }}"
                  >{{ description.unit ? description.unit : "*" }} &nbsp;
                  {{ description.description_cat }}</span
                >
              </div>
            </div>
            <div class="grid-product-value">
              <span>{{ product.value }}€ </span>
              <span>{{ "tables.vat_included" | translate }}</span>
            </div>
            <div class="product-card-actions">
              <button
                mat-flat-button
                (click)="toggleAlbumPhotosSelector(product.id)"
                class="add-to-checkout-button"
              >
                <span style="color: teal">{{
                  "inputs.create" | translate
                }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- <div *ngIf="!showProductsGrid" style="display: flex; margin: 0 25px">
  <div class="container">
    <div class="cards">
      <div *ngFor="let product of highlightedProducts">
        <div class="card highlighted">
          <div>
            <img class="grid-image" [src]="product.product_image" />
          </div>

          <div class="grid-card-title">
            <span style="display: {{ 'es' | translate }}">{{
              product.name_es
            }}</span>
            <span style="display: {{ 'en' | translate }}">{{
              product.name_en
            }}</span>
            <span style="display: {{ 'cat' | translate }}">{{
              product.name_cat
            }}</span>
          </div>
          <mat-divider style="width: 95%"></mat-divider>
          <div *ngFor="let description of productDescriptions[product.id]">
            <div>
              <span style="display: {{ 'es' | translate }}"
                >{{ description.unit ? description.unit : "*" }} &nbsp;
                {{ description.description_es }}</span
              >
              <span style="display: {{ 'en' | translate }}"
                >{{ description.unit ? description.unit : "*" }} &nbsp;
                {{ description.description_en }}</span
              >
              <span style="display: {{ 'cat' | translate }}"
                >{{ description.unit ? description.unit : "*" }} &nbsp;
                {{ description.description_cat }}</span
              >
            </div>
          </div>
          <div class="grid-product-value">
            <span>{{ product.value }}€ </span>
            <span>{{ "tables.vat_included" | translate }}</span>
          </div>
          <div class="product-card-actions">
            <button
              mat-flat-button
              (click)="toggleAlbumPhotosSelector(product.id)"
              class="add-to-checkout-button"
            >
              <span style="color: teal">{{ "inputs.create" | translate }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->

<!-- PRODUCT SELECTION GRID FOR ALBUMS-->
<div *ngIf="showProductsGrid" class="grid">
  <span class="grid-title">
    {{ "alerts.you_have_selected" | translate }}
    {{ albumSelectionIdList.length }}
    {{ ("titles.list.photo" | translate).toLowerCase() }}.
    {{ "alerts.min" | translate }} {{ albumMin }} /
    {{ "alerts.max" | translate }} {{ albumMax }}
    {{ "alerts.photos_per_prod" | translate }}.
  </span>
  <div class="grid-elements">
    <div *ngFor="let item of reportages">
      <div class="grid-highlighted-element" (click)="onAlbumItemSelected(item)">
        <div
          *ngIf="albumSelectionIdList.indexOf(item.id) != -1"
          class="overlay"
        >
          <mat-icon>check</mat-icon>
        </div>
        <div class="item">
          <div class="grid-card-title">
            <span>{{ item.name }}</span>
          </div>
          <div>
            <img class="grid-image" [src]="item.data" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="float-button-container two-button-layout"
    style="right: 50px; bottom: 40px"
  >
    <button
      mat-flat-button
      class="back-button"
      (click)="toggleAlbumPhotosSelector()"
    >
      <mat-icon>keyboard_arrow_left</mat-icon>
      <span>&nbsp; {{ "inputs.back" | translate }}</span>
    </button>
    <div
      *ngIf="albumSelectionIdList.length > 0"
      class="button-badge"
      [ngClass]="
        albumSelectionIdList.length >= albumMin &&
        albumSelectionIdList.length <= albumMax
          ? 'check'
          : ''
      "
    >
      {{ albumSelectionIdList.length }}
    </div>
    <button
      style="color: white; background-color: #5fbeb5"
      mat-raised-button
      class="save-changes-button"
      (click)="saveAlbumSelection()"
    >
      <span>{{ "buttons.add_to_cart" | translate }}</span>
    </button>
  </div>
</div>

<!-- BOTON PROVISIONAL QUE SE MUESTRA SI ESTAMOS DENTRO DE LA PARRILLA DE PRODUCTOS PARA VOLVER A LA TABLA DE PRODUCTOS -->
<!-- <div class="float-button-container" style="right: 50px">
  <button
    *ngIf="showProductsGrid"
    mat-flat-button
    (click)="showProductsGrid = !showProductsGrid"
    class="save-changes-button"
  >
    <mat-icon>arrow_back</mat-icon>
    <span>{{ "buttons.add_products" | translate }}</span>
  </button>
</div> -->

<div
  *ngIf="total_products > 0 && !showProductsGrid"
  style="padding: 64px 26px 0"
>
  <mat-divider style="width: 100%; border-top-color: black"></mat-divider>

  <div>
    <p style="font-weight: bold; font-size: 18px; margin-top: 18px">
      {{ "titles.list.add_individual_items" | translate }}
    </p>
    <!-- <p>{{ "text.non_priority_products_intro" | translate }}</p> -->
  </div>
</div>

<!-- PRODUCT SELECTION GRID -->
<div class="grid" *ngIf="total_products > 0 && !showProductsGrid">
  <div class="grid-elements">
    <div *ngFor="let reportage of reportages">
      <div class="grid-element">
        <div class="item">
          <div style="width: 100%; height: 200px">
            <img
              class="grid-image"
              [src]="reportage.data"
              (click)="!mobileView && openPhotoPreview(reportage.data)"
              [ngClass]="{ 'zoom-in-cursor': !mobileView }"
            />
          </div>
          <div class="grid-card-title">
            <span>{{ reportage.name }}</span>
          </div>
          <mat-divider style="width: 95%; margin: 8px"></mat-divider>

          <!-- Product selector -->
          <mat-form-field appearance="legacy">
            <mat-label>{{ "inputs.products" | translate }}</mat-label>
            <mat-select
              matNativeControl
              [(value)]="selected"
              (selectionChange)="changePrice($event.value)"
            >
              <mat-option *ngFor="let product of products" [value]="product">
                {{ product["name_" + selectedLanguage] }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <!-- <br>
                    {{'tables.description' | translate}} -->
          <mat-divider style="width: 95%"></mat-divider>
          <div *ngFor="let description of productDescriptions[productSelected]">
            <div>
              <span style="display: {{ 'es' | translate }}"
                >{{ description.unit ? description.unit : "*" }} &nbsp;
                {{ description.description_es }}</span
              >
              <span style="display: {{ 'en' | translate }}"
                >{{ description.unit ? description.unit : "*" }} &nbsp;
                {{ description.description_en }}</span
              >
              <span style="display: {{ 'cat' | translate }}"
                >{{ description.unit ? description.unit : "*" }} &nbsp;
                {{ description.description_cat }}</span
              >
            </div>
          </div>

          <div class="grid-product-value">
            <span>{{ price }} € </span>
            <span>{{ "tables.vat_included" | translate }}</span>
          </div>

          <div class="product-card-actions">
            <div class="grid-product-quantity-selector">
              <span style="font-size: 14px">
                {{ "buttons.quantity_short" | translate }}:
              </span>

              <button
                mat-button
                [matMenuTriggerFor]="summaryMenu"
                class="quantity-select-button"
              >
                <span>{{ prodQtyOverview[reportage.id].unit }} &nbsp;</span>
                <mat-icon> keyboard_arrow_down </mat-icon>
              </button>
              <mat-menu #summaryMenu="matMenu">
                <div style="height: 200px; text-align: center">
                  <div *ngFor="let number of numberList">
                    <button
                      mat-menu-item
                      (click)="
                        productQuantitySelectHandler(number, reportage.id)
                      "
                      style="text-align: center"
                    >
                      <span>{{ number }}</span>
                    </button>
                  </div>
                </div>
              </mat-menu>
            </div>

            <button
              mat-flat-button
              (click)="addToShoppingCart(reportage.id, price, productSelected)"
              class="add-to-checkout-button"
            >
              <span>{{ "buttons.add_product" | translate }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div style="clear: left"></div>
<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
<mat-paginator
  [length]="totalItems"
  [pageSizeOptions]="[100, 20, 50]"
  (page)="pageEvent = $event; onPaginateChange($event)"
  showFirstLastButtons
  *ngIf="total_products > 0"
>
</mat-paginator>
